export default __webpack_public_path__ + "static/media/portfolio.7db48af6.jpg";